import { createFileRoute, Outlet } from "@tanstack/react-router";
import { NancyFacilityGate } from "@/routes/_authenticated/nancy/-lib/nancy-facility-gate";

/** Pathless layout over Nancy's order and settings screens, which each need one building chosen.
 * The orders list at `/ws/nancy` stays outside it and asks for a building itself. */
export const Route = createFileRoute("/_authenticated/ws/nancy/_gate")({
  component: NancyGateLayout,
});

function NancyGateLayout() {
  return (
    <NancyFacilityGate>
      <Outlet />
    </NancyFacilityGate>
  );
}
